import { FC, CSSProperties } from 'react';
import { Status as PolicyStatus } from '@agilelab/plugin-wb-governance-common';
import { useTheme } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import { IconLabelBox } from '../../IconLabelBox';
import { useStyles } from './style';
import { WbInfoTooltip } from '../../WbInfoTooltip';

interface Props {
  policyStatus?: PolicyStatus;
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

function titleFromStatus(policyStatus?: PolicyStatus): string {
  switch (policyStatus) {
    case PolicyStatus.Grace: {
      return 'Failed. This policy is in the grace period, so it is not blocking the deployment. Check and solve the errors, since they will block the deployment when this will become enabled';
    }
    case PolicyStatus.Deprecated: {
      return 'Failed. This policy is deprecated, so it is not blocking the deployment. Check the errors, but remember that this policy will be removed';
    }
    default: {
      return 'Failed. This policy is in a state that does not prevent the deployment';
    }
  }
}

export const NotBlockingIcon: FC<Props> = ({
  policyStatus,
  style,
  variant = 'default',
}) => {
  const theme = useTheme();
  const classes = useStyles();
  return (
    <WbInfoTooltip
      title={titleFromStatus(policyStatus)}
      icon={
        <span>
          {variant === 'reduced' ? (
            <ErrorIcon
              className={`${classes.icon}`}
              htmlColor={theme.palette.warning.main}
              style={{ ...style, transform: 'scale(1.2)' }}
            />
          ) : (
            <IconLabelBox
              label="Failure*"
              backgroundColor={theme.palette.warning.main}
              icon={
                <PriorityHighIcon
                  style={style}
                  htmlColor={theme.palette.black}
                />
              }
            />
          )}
        </span>
      }
    />
  );
};
